export default [{
    title: 'Localidades',
    name: 'access-locations',
    path: '/access-locations',
    component: () => import( /* webpackChunkName: "series" */ './AccessLocations')
}]